import React, {useState, useEffect} from 'react';
import {ToggleButton, ButtonGroup} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {useBreakpoint} from '../util/handleBreakpoints';

const Sidebar = (props) => {
    const {t} = useTranslation();
    const breakpoints = useBreakpoint();

    const [visibleChildren, setVisibleChildren] = useState(false);
    const [visibleChildrenCompact, setVisibleChildrenCompact] = useState(false);

    useEffect(() => {
        if (breakpoints.md) {
            if (visibleChildrenCompact) {
                setVisibleChildren(true);
            } else {
                setVisibleChildren(false);
            }
        } else {
            setVisibleChildren(true);
            setVisibleChildrenCompact(false);
        }
    }, [breakpoints, visibleChildren, visibleChildrenCompact, setVisibleChildren, setVisibleChildrenCompact])

    useEffect(() => {
        if (props.compactVisibility) {
            const hide = props.compactVisibility[0];
            const hideToggle = props.compactVisibility[1];
            if (hide === true) {
                hideToggle(false);
                setVisibleChildrenCompact(false);
            }
        }
    }, [props.compactVisibility, visibleChildrenCompact]);

    return <div
        style={{
            position: `relative`,
            display: `flex`,
            maxHeight: `calc(100vh - 44px)`,
            order: breakpoints.md ? 2 : (props.right ? 2 : 0),
            height: (breakpoints.md ? (visibleChildrenCompact ? `100%` : `auto`) : `100%`),
            flexDirection: `column`,
            maxWidth: '27rem',
            minWidth: (breakpoints.md ? `100vw` : '25rem'),
            flexShrink: 0,
            width: '100%',
            ...props.style
        }}
    >
        <div
            style={
                {
                    width: `100%`,
                    display: `flex`,
                    height: (visibleChildren ? `100%` : 0),
                    overflow: `auto`,
                    flexDirection: `column`,
                    pointerEvents: (visibleChildren ? `true` : `false`),
                    order: 1,
                    borderRight: breakpoints.md ? 'none' : '3px solid #eee'
                }
            }
            className={`bg-light`}
        >
            {props.children}
        </div>
        {
            breakpoints.md ?
                <div
                    style={
                        {
                            display: `flex`,
                            width: `100%`,
                            order: 2,
                            height: '56px',
                            flexShrink: 0,
                        }
                    }
                    className={`px-2 py-2 border-top`}
                >
                    <div
                        style={
                            {
                                display: `flex`,
                                alignItems: `center`,
                                height: `100%`,
                                zIndex: 2,
                                flexGrow: 1,
                                marginRight: '0.5rem'
                            }
                        }
                        className="text-light"
                    >
                        {props.toggleMeta}
                    </div>
                    <ButtonGroup
                        className="ml-auto"
                        toggle
                    >
                        <ToggleButton
                            type="checkbox"
                            checked={visibleChildren}
                            onChange={() => {
                                setVisibleChildrenCompact(!visibleChildrenCompact);
                            }}
                            variant="outline-primary"
                        >
                            {
                                visibleChildrenCompact ?
                                <span>{props.toggleTitleHide ? props.toggleTitleHide : t('Sidebar.sidebar-menu-hide')}</span> :
                                <span>{props.toggleTitleShow ? props.toggleTitleShow : t('Sidebar.sidebar-menu-show')}</span>
                            }
                        </ToggleButton>
                    </ButtonGroup>
                </div> :
                null
        }
    </div>
}

export default Sidebar;
